import Image from 'next/image'
import React from 'react'
import styled from 'styled-components'

import { GutShotListItemWithIcon } from '@/components/pages/gutshot/GutShotListWithIcon'
import { MediaAndContentLayout } from '@/components/pages/gutshot/MediaAndContentLayout'
import { ListWithIcons } from '@/components/pages/self-serve/blocks/ListWithIcon'

const StyledListTitle = styled.h2`
  font-size: 46px;
  line-height: 64px;
  font-family: ${(p) => p.theme.v2.font.nantes};
  color: ${(props) => props.theme.v2.onSurface.text};
  max-width: 500px;
  padding-bottom: 18px;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: ${(p) => p.theme.v2.typography.body.l.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.l.lineHeight};
    padding-bottom: 8px;
    margin-top: 8px;
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    font-size: 34px;
    line-height: 48px;
    margin-top: 16px;
    padding-bottom: 16px;
  }
`

export const GutShotBenefitsList = () => {
  return (
    <MediaAndContentLayout
      content={
        <div>
          <StyledListTitle>Benefits of improving your gut health</StyledListTitle>
          <ListWithIcons>
            <GutShotListItemWithIcon text="Higher energy levels" />
            <GutShotListItemWithIcon text="Less hunger" />
            <GutShotListItemWithIcon text="Feel less bloated" />
            <GutShotListItemWithIcon text="Sleep better" />
          </ListWithIcons>
        </div>
      }
      orientation="left"
      media={
        <Image src="/assets/img/gutshot/michelle-gutshot.jpg" width={670} height={670} alt="Michelle loving life." />
      }
    />
  )
}
